import WaterIntake from '../sections/waterIntake/waterIntake';

export default function WaterIntakePage() {
  return (
    <div className="section-page">
      <WaterIntake />
    </div>
  );
}
